import styled from 'styled-components'

type FadeInProps = {
  $show: boolean
}

const FadeIn = styled.div<FadeInProps>`
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  transition: visibility 0s linear 300ms, z-index 0s linear 300ms,
    opacity 300ms ease-out;

  ${({ $show }) =>
    $show &&
    `
    visibility: visible;
    opacity: 1;
    z-index: 3;
    transition: visibility 0s linear 0s, z-index 0s linear 0s, opacity 300ms ease-out;
  `}
`

export default FadeIn
